import React from 'react';
import { connect } from 'react-redux';
import gql from 'graphql-tag';
import { useQuery } from '@apollo/react-hooks';

import DesktopHeader from './DesktopHeader';
import MobileHeader from './MobileHeader';

import { getNavNodesProperties } from '../../../../utils/data-transformers/getNavNodeProperties';

const NAV_NODE_QUERY = gql`
  {
    navNodes {
      childNodes {
        childNodes {
          color
          childNodes {
            id
          }
          customUrl
          id
          promos {
            link: linkUrl
            source: imageSrc
            title: imageAlt
          }
          slug
          title: fullTitle
          type
        }
        color
        customUrl
        id
        promos {
          link: linkUrl
          source: imageSrc
          title: imageAlt
        }
        slug
        title: fullTitle
        type
      }
      color
      customUrl
      id
      level
      mobileDefaultCrossSellingTab
      mobileFlyerCategories
      promos {
        link: linkUrl
        source: imageSrc
        title: imageAlt
      }
      slug
      title: fullTitle
      type
    }
  }
`;

function PlatformDetectHeader({ isMobile }) {
  const { loading, error, data = {} } = useQuery(NAV_NODE_QUERY);

  if (error || loading || !data.navNodes) {
    return null;
  }

  const { navNodes } = data;
  const nodes = getNavNodesProperties(navNodes);

  return isMobile ? (
    <MobileHeader nodes={nodes} />
  ) : (
    <DesktopHeader nodes={nodes} />
  );
}

const mapStateToProps = ({ env: { isMobile } }) => ({
  isMobile,
});

export default connect(mapStateToProps)(PlatformDetectHeader);
